<template>
  <div class="card-job-list">
    <div v-if="jobs.length === 0" class="card-job-list-empty">
      <i class="fa-regular fa-calendar-check"></i>
      <span>Nenhuma tarefa adicionada!</span>
    </div>

    <div v-else class="card-job-list-items">
      <div v-for="item in jobs" :key="item.id" class="card-job-list-item">
        <img
          v-b-tooltip.hover
          :title="item.registeredUser"
          :src="photoUrl(item.photo)"
          class="card-job-list-avatar"
          alt="Responsável"
        />

        <div class="card-job-list-item-main" @click="editJob(item)">
          <div class="card-job-list-item-subject">{{ item.subject }}</div>
          <div class="card-job-list-item-date">
            {{ item.dateStart }} {{ item.timeStart }}
            <span v-if="item.dateEnd"> - {{ item.dateEnd }} {{ item.timeEnd }}</span>
          </div>
        </div>

        <div class="card-job-list-item-status">
          <span :class="statusDotClass(item.status)" class="card-job-list-item-status-dot"></span>
          <span class="card-job-list-item-status-text">{{ item.status }}</span>
        </div>

        <div class="card-job-list-item-remove" @click="removeJob(item)">
          <Loading v-if="isLoading(item.id)" type="bubbles" :center="false" :width="20" :height="20" />
          <i v-else class="fa-solid fa-trash"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/ui/shared/Loading.vue";

import CardService from "../../services/card.service";

import { mapGetters, mapMutations } from "vuex";

const PHOTO_BASE_URL = "https://espaco.blob.core.windows.net/nixloc-photo-user/";

const STATUS_DOT_CLASS = {
  "Hoje": "card-job-list-status-today",
  "Pendente": "card-job-list-status-late",
  "Conclu\u00EDda": "card-job-list-status-done",
  "Prazo": "card-job-list-status-scheduled",
};

export default {
  name: "CardJobList",
  components: { Loading },
  props: {
    cardId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      jobs: [],
    };
  },
  mounted() {
    this.loadJobs();
  },
  computed: {
    ...mapGetters("generic", ["event", "isLoading"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "addLoading", "removeLoading"]),
    async loadJobs() {
      const response = await CardService.getAllJobs(this.cardId);
      this.jobs = response.data.content.data;
      this.$emit("count-change", this.jobs.length);
    },
    photoUrl(photo) {
      return PHOTO_BASE_URL + (photo || "noImage.png");
    },
    statusDotClass(status) {
      return STATUS_DOT_CLASS[status] || "";
    },
    editJob(item) {
      this.addEvent({ name: "jobCardEdit", data: item });
    },
    async removeJob(item) {
      if (this.isLoading(item.id)) return;
      this.addLoading(item.id);
      try {
        await CardService.removeJob(item.id);
        await this.loadJobs();
      } finally {
        this.removeLoading([item.id]);
      }
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name === "jobSaved") this.loadJobs();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.card-job-list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 0;
  color: var(--text-muted);
  font-size: 14px;
}

.card-job-list-empty i {
  font-size: 28px;
}

.card-job-list-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-job-list-item {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  background: var(--bg-base);
  padding: 8px 12px;
  transition: background 0.15s;
}

.card-job-list-item:hover {
  background: var(--bg-hover);
}

.card-job-list-avatar {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  object-fit: cover;
  flex-shrink: 0;
}

.card-job-list-item-main {
  flex: 1;
  min-width: 0;
  cursor: pointer;
}

.card-job-list-item-subject {
  font-size: 14px;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-job-list-item-date {
  font-size: 13px;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-job-list-item-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  margin-right: 12px;
}

.card-job-list-item-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  flex-shrink: 0;
}

.card-job-list-status-late { background-color: var(--color-danger); }
.card-job-list-status-done { background-color: var(--color-success); }
.card-job-list-status-today { background-color: var(--color-warning); }
.card-job-list-status-scheduled { background-color: var(--color-brand); }

.card-job-list-item-status-text {
  font-size: 13px;
  color: var(--text-secondary);
}

.card-job-list-item-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: var(--color-danger);
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.15s;
}

.card-job-list-item-remove:hover {
  opacity: 0.7;
}
</style>
